import React from 'react'
import PropTypes from 'prop-types'
import Img from '../../../../../../src/components/shared/Img'
import Hyperlink from '../../../HyperLink'
import { generateElementId } from '../../../../../common/helpers'
import SvgIcon from '../../../SvgIcon'

const RecommendedReadsItem = ({
  img: { src, alt },
  title,
  subtitle,
  description,
  link,
  isMobile,
  isFullSizeMobile,
}) => (
  <div
    className={`gap-primary bg-inherit grid rounded-md lg:grid-cols-12 lg:border lg:bg-white lg:p-8`}
    id={`recommended-reads-item-${generateElementId(title)}`}
    data-testid="recommended-reads-item"
    style={{ marginLeft: isMobile && isFullSizeMobile ? '0' : '1rem' }}
  >
    <Img
      src={src}
      alt={alt}
      width={640}
      height={360}
      className="lg:col-span-6"
      imgClassName="img-radius"
      layout="intrinsic"
      objectFit="cover"
      styles={{ position: 'relative' }}
    />
    <div className="my-auto pt-4 lg:col-span-5 lg:pt-0">
      <div className="lg:min-h-40" data-testid="recommended-reads-item-content">
        <p
          className="text-sm text-gray-940"
          data-testid="recommended-reads-item-title"
        >
          {title}
        </p>
        <Hyperlink
          href={link}
          title={title}
          data-testid="recommended-reads-item-link"
        >
          <p
            className="min-h-25 pt-4 text-2xl font-medium text-black-base sm:min-h-20 lg:min-h-0"
            data-testid="recommended-reads-item-subtitle"
          >
            {subtitle}
          </p>
        </Hyperlink>
        {description ? (
          <p
            className="mt-4 text-15 text-black-base-light"
            data-testid="recommended-reads-item-description"
          >
            {description}
          </p>
        ) : null}
      </div>
      <Hyperlink
        childrenClassNames="flex pt-5 text-15 font-bold leading-7 text-blue-base lg:pt-0 lg:text-lg"
        href={link}
        title={title}
        data-testid="recommended-reads-link"
      >
        Learn&nbsp;more
        <SvgIcon
          name="chevronThinRight"
          className="size-5 my-auto ml-1.5 fill-blue-base"
        />
      </Hyperlink>
    </div>
  </div>
)

RecommendedReadsItem.defaultProps = {
  description: '',
}

RecommendedReadsItem.propTypes = {
  img: PropTypes.shape({
    src: PropTypes.string.isRequired,
    alt: PropTypes.string.isRequired,
  }),
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  description: PropTypes.string,
  link: PropTypes.string.isRequired,
}

export default RecommendedReadsItem
